import React from 'react';

const diameter = window.innerWidth > 899 ? "227px" : "333px";

const CircleHead = (props) => (
  <div className={props.className} tabIndex="-1" style={{
    padding: "0",
    height: props.size,
    width: props.size,
    borderRadius: "50%",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(" + props.image + ")",
    backgroundPositionX: props.nudgeX,
    backgroundPositionY: props.nudgeY,
    backgroundSize: props.backgroundSize,
    ...props.styles,
  }}>
  </div>  
);

CircleHead.defaultProps = {
  styles: "",
  className: "circleHead",
  children: "No Image Provided",
  size: diameter, 
  backgroundSize: diameter + " " + diameter,
  nudgeX: "10%", 
  nudgeY: "10%", 
  image: "https://www.uvm.edu/content/sites/all/themes/uvm_admin/images/uvmlogo-lite.svg",
};

export default CircleHead;
